import { PageHeader } from "@/components/PageHeader";

export default function MoldReturnPage() {
  return (
    <div className="flex flex-col bg-background">
      <PageHeader title="금형회수" />

      <main className="flex-1 p-6">
        <div className="container mx-auto">
          <p className="text-gray-600 dark:text-gray-400">
            This is mold-return page
          </p>
        </div>
      </main>
    </div>
  );
}
